<div class="menu-container">
    <div class="menu-header">
        <div class="back-arrow">
            <button class="dotted-arrow" mat-icon-button (click)="onCloseMenu()">←</button>
        </div>
        <h3 class="headline" i18n="@@list-quotes_headline">Wishlist</h3>
    </div>

    <div class="menu-item" i18n="@@quote-view-selection_create-new-quote" (click)="onOpenCreateQuote()">Create new quote</div>
    <div class="menu-item" i18n="@@quote-view-selection_quotes" (click)="onOpenQuotesList()">Quotes</div>
    <div class="menu-item" i18n="@@quote-view-selection_submitted-quotes" (click)="onOpenSubmittedQuotesList()">Submitted</div>
</div>
